

export default function (value) {
  var res = void 0;
  var rej = void 0;

  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });

  promise.resolve = res;
  promise.reject = rej;
  promise.inputValue = value;

  return promise;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-sdk/dist/ejs/defer.js
// module id = 1238
// module chunks = 0